import {
  SET_STEP,
  API_ERROR,
  API_CLEAR_ERROR,
} from 'Src/constants';

export const updateStep = payload => ({
  type: SET_STEP,
  payload,
});

export const apiError = payload => ({
  type: API_ERROR,
  payload,
});

export const apiClearError = () => ({ type: API_CLEAR_ERROR });
